import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { SendFilterFormMode } from 'src/components/Search/Common/Filters/actions/sendFilterForm';
import { useSendFilterForm } from 'src/components/Search/Common/Filters/hooks/useSendFilterForm';
import { resetSearchDraftClusters } from 'src/models/search/common/clusters/draft';
import { resetSearchDraftClustersOrder } from 'src/models/search/common/clustersOrder/draft';
import { setSearchGeoDrawerClosed } from 'src/models/search/common/geoDrawer';

export const useSubmitDraftForm = (): (() => void) => {
    const dispatch = useDispatch();

    const sendFilterForm = useSendFilterForm();

    return useCallback(() => {
        dispatch(setSearchGeoDrawerClosed());
        sendFilterForm({ mode: SendFilterFormMode.ApplyFiltersFromDraft });
        dispatch([resetSearchDraftClusters(), resetSearchDraftClustersOrder()]);
    }, [dispatch, sendFilterForm]);
};
